import { Component, OnInit } from "@angular/core";
import { Constants } from "../Services/Constants";
import { HTTPService } from "../Services/http.service";
import { Observable } from "rxjs/Observable";
import { filter } from "../App/search.pipe";
import { MySharedService } from "../App/shared.service";
import { ActivatedRoute, Router } from "@angular/router";
import { ReturnStatement } from "@angular/compiler/src/output/output_ast";

declare function ExportToExcel(
  item: any[],
  workSheetName: string,
  keys: any,
  Columns?: any
): void;

@Component({
  templateUrl: "./AppViews/MyTask/MyTaskListCustomer.html",
})
export class MyTaskListCustomerComponent implements OnInit {
  userDetail: any;
  public constants: Constants;
  public myTask: any[] = [];
  public myCustomer: any[] = [];
  public usersItems: any[] = [];
  public projectList: any[] = [];
  public PriorityItems: any[] = [];
  public StatusItems: any[] = [];
  public userTypeInfo: any[] = [];
  public taskTypeItems: any[] = [];
  public TaskList: any[] = [];
  public customerItem: any[] = [];
  public TaskItems: any[] = [];
  public ModuleList: any[] = [];
  public CheckList: any[] = [];
  public isAdd: boolean = true;
  public IsCreated: boolean = true;
  public IsStatusOpen: boolean = true;
  public IsCreatedBy: boolean = false;
  public IsCompleted: boolean = false;
  public IsSubmit: boolean = true;
  active = true;
  filter: any = { TeamId: "", TypeId: "", Status: "" };
  public subscription: any;
  public showLoader = false;
  public isFormSubmitted: boolean = false;
  public Search: any = "";
  public edithide: boolean = true;
  public addhide: boolean = false;
  public greater = false;
  public actualDateGreater = false;
  public CheckListName: any;
  public SequenceId: any = 1;
  public addMyTask: any = {};
  public editMyTask: any = [];
  public TaskStrike: boolean = false;
  public editTaskTypeId: any = 0;
  public TaskDetails: any = {
    ProjectId: "",
    ModuleId: "",
    TaskGroupId: "",
    AssignTo: "",
  };
  public taskgroupList: any[] = [];
  constructor(
    private _httpService: HTTPService,
    private _sharedService: MySharedService,
    private activatedRoute: ActivatedRoute,
    private _Router: Router
  ) {
    this.subscription = this.activatedRoute.queryParams.subscribe(
      (param: any) => {
        if (param["myTask"]) {
          console.log(JSON.stringify(JSON.parse(param["myTask"])));
          this.editTaskTypeId = JSON.parse(param["myTask"]);
          this.edithide = false;
          this.addhide = true;
        }
      }
    );
    this.constants = new Constants();
    this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
    if (JSON.parse(localStorage.getItem("TaskDetailsFilters")) != null)
      this.TaskDetails = JSON.parse(localStorage.getItem("TaskDetailsFilters"));
  }

  newForm() {
    this.active = false;
    setTimeout(() => (this.active = true), 0);
  }

  ngOnInit() {
    this.GetTaskList(0);

    if (this.addhide == true && this.edithide == false) {
      this.getMyTask();
      this.GetCheckList();
    } else {
      this.getUsers(0);
      this.addMyTask.IsActive = true;
      this.addMyTask = {
        ProjectId: this.TaskDetails.ProjectId,
        ModuleId: this.TaskDetails.ModuleId,
        TaskGroupId: this.TaskDetails.TaskGroupId,
        TaskName: "",
        TaskDescription: "",
        AssignTo: this.TaskDetails.AssignTo,
        Priority: 3,
        TaskOwner: this.userDetail.SiteUserId,
        EstimatedTime: "",
        PlannedStartDate: moment(new Date()).format("DD/MM/YYYY"),
        PlannedEndDate: moment().add(7, "days").format("DD/MM/YYYY"),
        ParentId: "",
        PredecessorId: "",
        DisplayOrder: "",
        RemainderForStartDate: true,
        RemainderForEndDate: true,
        IsPrivate: false,
      };
      if (
        this.TaskDetails.ProjectId != "" &&
        this.TaskDetails.ProjectId != null
      ) {
        this.callFunction(this.TaskDetails.ProjectId);
      }
    }

    this.getPriority();
    this.GetProjectList();
  }

  ngAfterViewInit() {
    $("#show-filter").click(function () {
      $(".filter-form").slideToggle();
    });

    //var today = moment().format('YYYY-MM-DD');  maxDate: today
    $(".date").datetimepicker({
      format: "DD/MM/YYYY",
    });

    (this.addMyTask.PlannedStartDate = moment(new Date()).format("DD/MM/YYYY")),
      $("#show-filter").click(function () {
        $(".filter-form").slideToggle();
      });
    (this.addMyTask.PlannedEndDate = moment()
      .add(7, "days")
      .format("DD/MM/YYYY")),
      $("#show-filter").click(function () {
        $(".filter-form").slideToggle();
      });

    setTimeout(() => {
      $("#teammultiselect").multiselect({
        enableFiltering: false,
        includeSelectAllOption: true,
        selectAllJustVisible: false,
      });

      $("#teammultiselect option").each(function () {
        if ($(this).attr("selected") == "selected") {
        }
      });
    }, 1000);
  }

  public AddTeamFormLoad() {
    $("#btnAddTeamForm").trigger("click");
  }

  public ResetForm(form: any) {
    form.reset();
    form.resetForm();
    this.isFormSubmitted = false;
  }

  public GetTaskLists(projectid) {
    this._httpService
      .ajaxPost("MyTask/GetTaskList", {
        ProjectId: projectid,
        logginUserId: this.userDetail.SiteUserId,
      })
      .subscribe((data) => {
        this.TaskItems = data["TaskList"];
        if (this.addhide == true && this.edithide == false)
          this.TaskItems = JSON.parse(
            JSON.stringify(
              this.TaskItems.filter((m) => m.TaskId != this.editMyTask.TaskId)
            )
          );
      });
  }

  public GetParentLists(projectid) {
    this._httpService
      .ajaxPost("MyTask/GetParentList", { ProjectId: projectid })
      .subscribe((data) => {
        // this.TaskItems = data["ParentList"];
      });
  }

  public changeStatus() {
    if (this.editMyTask.Status == 1) this.editMyTask.Status = 2;
  }

  public changeStatusForTaskStart() {
    if (
      this.editMyTask.PredecessorId != null &&
      this.editMyTask.PredecessorId != "" &&
      this.editMyTask.PredcessorStatus != 4
    ) {
      this._sharedService.ShowMessage(
        "warning|Predessor task is not completed"
      );
    }
    if (this.editMyTask.Status == 2 || this.editMyTask.Status == 1)
      this.editMyTask.Status = 3;
  }

  public changeStatusForTaskEnd() {
    this.editMyTask.Status = 4;
  }

  changeStatusForReOpen() {
    this.editMyTask.Status = 3;
  }
  CheckListCompleted(item, event) {
    if (event == true) {
      item.CompletedBy = this.userDetail.SiteUserId;
      item.CompletedDate = null;
    } else {
      item.CompletedBy = null;
      item.CompletedDate = null;
    }

    if (this.edithide == false) {
      this.AddCheckList();
    }
  }
  public getUsers(projectid) {
    this._httpService
      .ajaxPost("TimeSheet/GetUsersByProject", {
        Project_Id: projectid,
        IsActive: this.constants.enumUserStatus["Active"],
        Team_Id: "0",
        ProjectType: 0,
        Status: 1,
        UserId: 0,
      })
      .subscribe((data) => {
        this.usersItems = data["Users"];
      });
  }

  public getPriority() {
    this._httpService
      .ajaxPost("Common/GetParameter", {
        ParameterTypeId: this.constants.enumParamterTypeName["TaskStatus"],
      })
      .subscribe((data) => {
        this.PriorityItems = data["Parameter"];
      });
  }

  AddCheckListToList() {
    if (this.CheckListName.trim() != "" && this.CheckListName != null) {
      if (this.validateCheckList()) {
        var Complteduser: number = null;
        var CompltedDate: any = null;

        if (this.TaskStrike) {
          Complteduser = this.userDetail.SiteUserId;
          CompltedDate = null;
        }

        var CheckListItem = {
          TaskCheckListId: 0,
          CheckListName: this.CheckListName,
          Status: 0,
          CompletedBy: Complteduser,
          CompletedDate: CompltedDate,
          SequenceId: this.SequenceId,
          TaskCompleted: this.TaskStrike,
        };

        this.TaskStrike = false;
        this.CheckList.push(CheckListItem);
        this.SequenceId = this.SequenceId + 1;
        this.CheckList = JSON.parse(JSON.stringify(this.CheckList));
        this.CheckListName = "";

        if (this.edithide == false) {
          this.AddCheckList();
        }
      }
    }
  }
  AddCheckList() {
    this.showLoader = true;
    var objItem = {
      TaskId: this.editTaskTypeId,
      CheckList: this.CheckList,
    };
    this._httpService
      .ajaxPost("CheckList/AddUpdateCheckList", objItem)
      .subscribe(
        (data) => {
          var msg = data["Status"].Message.split("|");
          this._sharedService.ShowMessage(data["Status"].Message);
          this.GetCheckList();
        },
        (err) => {
          this.showLoader = false;
          this._sharedService.ShowMessage(this.constants.globalError);
        },
        () => {
          this.showLoader = false;
        }
      );
  }

  getPreviousTask() {
    this.showLoader = true;

    this._httpService
      .ajaxPost("MyTask/getPreviousTask", {
        UserId: this.userDetail.SiteUserId,
      })
      .subscribe((data) => {
        var PreviousTask = data["PreviousTask"];
        let objItem: any = {};
        this.addMyTask = {
          Customer_Id: "",
          ProjectId: "",
          ModuleId: "",
          ParentId: "",
           TaskGroupId: "",
          TaskTypeId: "",
          TaskName: "",
          TaskDescription: "",
          AssignTo: "",
          Priority: 3,
          TaskOwner: "",
          EstimatedTime: "",
          PredecessorId: "",
          PlannedStartDate: moment(new Date()).format("DD/MM/YYYY"),
          PlannedEndDate: moment().add(7, "days").format("DD/MM/YYYY"),
          RemainderForStartDate: false,
          RemainderForEndDate: false,
          IsPrivate: false,
          DisplayOrder: 1,
        };
        if (PreviousTask.length > 0) {
          this.addMyTask.Customer_Id = PreviousTask[0].Customer_Id;
          this.addMyTask.ProjectId = PreviousTask[0].ProjectId;
          this.callFunction(this.addMyTask.ProjectId);
          this.addMyTask.TaskOwner = this.userDetail.SiteUserId;
        }
      });
    this.showLoader = false;
  }

  GetCheckList() {
    this.showLoader = true;

    this._httpService
      .ajaxPost("CheckList/GetCheckList", { TaskId: this.editTaskTypeId })
      .subscribe((data) => {
        this.CheckList = data["CheckList"];
        this.SequenceId = 1;
        if (this.CheckList.length > 0) {
          this.CheckList.forEach((element) => {
            element.SequenceId = this.SequenceId;
            this.SequenceId = this.SequenceId + 1;
            if (
              element.CompletedBy != null &&
              element.CompletedBy != "" &&
              element.CompletedBy != 0
            ) {
              element.TaskCompleted = true;
            } else {
              element.TaskCompleted = false;
            }

            element.Status = 0;
            if (element.CompletedDate != null) element.CompletedDate = null;
          });
        }
      });
    this.showLoader = false;
  }
  DeleteCheckList(item) {
    this.CheckList = JSON.parse(
      JSON.stringify(
        this.CheckList.filter((m) => m.SequenceId != item.SequenceId)
      )
    );

    if (this.edithide == false) {
      this.AddCheckList();
    }
  }

  validateCheckList() {
    var mandatory = "";
    var invalid = "";
    var functional = "";

    if (this.CheckListName.length > 200) {
      mandatory =
        mandatory + "<br>CheckList length should be less than 200 charecter";
    }

    if (mandatory == "" && invalid == "" && functional == "") {
      return true;
    } else {
      var msg = "";
      if (mandatory != "") {
        msg = msg + "Please enter : " + mandatory;
        msg = msg + "<br>";
      }
      if (invalid != "") {
        msg = msg + "Please enter valid : " + invalid;
        msg = msg + "<br>";
      }
      if (functional != "") {
        msg = msg + functional;
      }
      this._sharedService.ShowMessage("error|" + msg);
    }
    return false;
  }

  public getStatus() {
    this._httpService
      .ajaxPost("Common/GetParameter", {
        ParameterTypeId: this.constants.enumParamterTypeName["TaskStatusType"],
      })
      .subscribe((data) => {
        this.StatusItems = data["Parameter"];
        //   if((this.editMyTask.Status==1||this.editMyTask.Status==2||this.editMyTask.Status==3))
        //   this.StatusItems =(this.StatusItems.filter((m) =>(m.Value == 5 ||m.Value == 6)))
        //   else if(this.editMyTask.Status==4)
        //   this.StatusItems =(this.StatusItems.filter((m) =>(m.Value == 7)))
        //   else
        //   this.StatusItems =(this.StatusItems.filter((m) =>(m.Value == 7||m.value == this.editMyTask.Status)))

        //   if(this.editMyTask.TaskOwner!=this.userDetail.SiteUserId && this.editMyTask.CreatedBy !=this.userDetail.SiteUserId)
        //         {
        //             this.StatusItems =(this.StatusItems.filter((m) =>(m.Value != 6 && m.Value != 7)))
        //         }
        //     if((this.editMyTask.ActualStartDate!= null&&this.editMyTask.Status!=5))
        //     {
        //         this.StatusItems =(this.StatusItems.filter((m) =>m.Value != 5))
        //     }
      });
  }

  public getAssignedProjectCustomer() {
    this.showLoader = true;
    this._httpService
      .ajaxPost("MyTask/GetCustomer", { UserId: this.userDetail.SiteUserId })
      .subscribe(
        (data) => {
          this.myCustomer = data["CustomerList"];
        },
        (err) => {
          this.showLoader = false;
          this._sharedService.ShowMessage(this.constants.globalError);
        },
        () => {
          this.showLoader = false;
        }
      );
  }

  GetProjectList() {
    this.showLoader = true;
    var CustomerId = 0;
    if (this.userDetail.CustomerId != null) {
      CustomerId = this.userDetail.CustomerId;
    }
    this._httpService
      .ajaxPost("Project/GetCustomerProject", {
        ProjectId: 0,
        CustomerId: CustomerId,
      })
      .subscribe(
        (data) => {
          this.projectList = data["ProjectList"];
        },
        (err) => {
          console.log("GetProjectList Failed");
          this.showLoader = false;
        },
        () => {
          this.showLoader = false;
        }
      );
  }

  callFunction(event) {
    this.getUsers(event);
    // this.GetTaskList(event);
    this.GetModule(event, 1);
    this.getTaskGroupByProjectId(event);
    this.GetTaskLists(event);
    this.GetParentLists(event);
  }

  GetModule(ProjectId, from) {
    this.showLoader = true;

    this._httpService
      .ajaxPost("ProjectModule/GetProjectModule", { ProjectId: ProjectId })
      .subscribe(
        (data) => {
          if (from == 1) {
            this.addMyTask.ModuleId = "";
          }
          if (data["ProjectModuleList"].length > 0) {
            this.ModuleList = data["ProjectModuleList"];
          } else {
            let objItem: any = {};

            objItem.ProjectId = ProjectId;
            objItem.ModuleName = "Main";
            //  objItem.ModuleId =0;

            this._httpService
              .ajaxPost("ProjectModule/AddUpdateProjectModule", objItem)
              .subscribe(
                (data) => {
                  this.GetModule(ProjectId, null);
                  this.addMyTask.ModuleId = "";
                },
                (err) => {
                  this.showLoader = false;
                  this._sharedService.ShowMessage(this.constants.globalError);
                },

                () => {
                  this.showLoader = false;
                }
              );
          }
        },
        (err) => {
          this.showLoader = false;
          this._sharedService.ShowMessage(this.constants.globalError);
        },

        () => {
          this.showLoader = false;
        }
      );
  }

  GetTaskList(val) {
    // if (val == "") {
    //     this.TaskList = [];

    // }
    // else {
    //    this.showLoader=true;
    //     this._httpService.ajaxPost("TaskType/GetTaskTypeByProjectId",
    //         { "ProjectId": val }).subscribe(
    //         data => {
    //             this.TaskList = data["TaskTypeList"];
    //         },
    //         err => {
    //             this.showLoader=false;
    //         },
    //         () =>{
    //             this.showLoader=false;
    //         }
    //         );
    // }

    this.showLoader = true;

    this._httpService
      .ajaxPost("TaskType/GetTaskTypeCustomer", {
        TaskTypeId: 0,
        TaskGroupId: 0,
        IsActive: true,
        roleId: this.userDetail.RoleId,
      })
      .subscribe(
        (data) => {
          this.TaskList = data["TaskType"];
        },
        (err) => {
          this.showLoader = false;
          this._sharedService.ShowMessage(this.constants.globalError);
        },
        () => {
          this.showLoader = false;
        }
      );
  }

  public getMyTask() {
    this.showLoader = true;
    this._httpService
      .ajaxPost("MyTask/GetTask", { TaskId: this.editTaskTypeId })
      .subscribe(
        (data) => {
          this.myTask = data["MyTask"];
          this.EditMyTask(this.myTask);
          if (
            this.editMyTask.TaskOwner == this.userDetail.SiteUserId ||
            this.editMyTask.CreatedBy == this.userDetail.SiteUserId
          ) {
            //this.IsSubmit =true;
            this.IsCreated = false;
            this.IsStatusOpen = false;
            console.log("dd" + this.IsCreated);
          }
          if (this.editMyTask.Status == 4) {
            this.IsCreatedBy = true;
            console.log("ww" + this.IsCreatedBy);
          }

          if (this.editMyTask.Status == 4 || this.editMyTask.Status == 7) {
            this.IsCompleted = true;
            this.IsCreated = true;
            // this.IsCreatedBy =true
            if (this.editMyTask.Status == 7) this.IsStatusOpen = true;

            if (
              this.editMyTask.TaskOwner == this.userDetail.SiteUserId ||
              this.editMyTask.CreatedBy == this.userDetail.SiteUserId
            ) {
              this.IsSubmit = true;
            } else {
              this.IsSubmit = false;
            }
          }
        },
        (err) => {
          this.showLoader = false;
          this._sharedService.ShowMessage(this.constants.globalError);
        },
        () => {
          this.showLoader = false;
        }
      );
  }

  public CancelMyTask() {
    // this.newForm();
    this._Router.navigateByUrl("/MyTaskListCustomer");
    this.isAdd = true;
    this.addMyTask = {};
  }

  public getTaskGroupByProjectId(val) {
    this.showLoader = true;
    this._httpService
      .ajaxPost("Project/GetProjectById", { ProjectId: val })
      .subscribe(
        (data) => {
          this.taskgroupList = data["ProjectList"];
        },
        (err) => {
          console.log("GetProjectidList Failed");
          this.showLoader = false;
        },
        () => {
          this.showLoader = false;
        }
      );
  }

  public AddMyTask() {
    this.isFormSubmitted = true;
    if (this.greater == false) {
      let objItem: any = {};
      objItem.TaskId = 0;
      objItem.Customer_Id = this.addMyTask.Customer_Id;
      objItem.ProjectId = this.addMyTask.ProjectId;
      objItem.ModuleId = this.addMyTask.ModuleId;
      objItem.ParentId = this.addMyTask.ParentId;
        objItem.TaskGroupId = this.addMyTask.TaskGroupId;
      objItem.TaskTypeId = this.addMyTask.TaskTypeId;
      objItem.TaskName = this.addMyTask.TaskName;
      objItem.TaskDescription = this.addMyTask.TaskDescription;
      objItem.AssignTo = this.addMyTask.AssignTo;
      objItem.Priority = this.addMyTask.Priority;
      objItem.TaskOwner = this.addMyTask.TaskOwner;
      objItem.EstimatedTime = this.addMyTask.EstimatedTime;
      objItem.PredecessorId = this.addMyTask.PredecessorId;
      objItem.PlannedStartDate = this.addMyTask.PlannedStartDate;
      objItem.PlannedEndDate = this.addMyTask.PlannedEndDate;
      objItem.RemainderForStartDate = this.addMyTask.RemainderForStartDate;
      objItem.RemainderForEndDate = this.addMyTask.RemainderForEndDate;
      objItem.IsPrivate = this.addMyTask.IsPrivate;
      objItem.DisplayOrder = this.addMyTask.DisplayOrder;
      objItem.Status = 2;
      objItem.IsReOpen = this.addMyTask.IsReOpen;
      objItem.ReOpenCount = this.addMyTask.ReOpenCount;
      objItem.IsTimeSheetSaved = false;
      objItem.TimeSheetDate = "";
      objItem.ActualTime = 0;
      objItem.Comments = "";
      objItem.CreatedBy = this.userDetail.SiteUserId;
      objItem.ModifiedBy = 0;
      objItem.CheckList = this.CheckList;

      this.TaskDetails = {
        ProjectId: this.addMyTask.ProjectId,
        ModuleId: this.addMyTask.ModuleId,
        TaskGroupId: this.addMyTask.TaskGroupId,
        AssignTo: this.addMyTask.AssignTo,
      };
      localStorage.setItem(
        "TaskDetailsFilters",
        JSON.stringify(this.TaskDetails)
      );
      this.addEditMyTask(objItem);
      $("#addMyTask").modal("hide");
      //    this.addMyTask = {};
      this.isAdd = true;
    } else {
      if (this.greater) {
        this._sharedService.ShowMessage(
          "warning|Start Date should be greater than Due Date"
        );
      }
    }
  }

  public EditTask() {
    if (this.greater == false && this.actualDateGreater == false) {
      let objItem: any = {};

      objItem.TaskId = this.editMyTask.TaskId;
      objItem.Customer_Id = this.editMyTask.Customer_Id;
      objItem.ProjectId = this.editMyTask.ProjectId;
      objItem.ModuleId = this.editMyTask.ModuleId;
      objItem.ParentId = this.editMyTask.ParentId;
      objItem.TaskGroupId = this.editMyTask.TaskGroupId;
      objItem.TaskTypeId = this.editMyTask.TaskTypeId;
      objItem.TaskName = this.editMyTask.TaskName;
      objItem.TaskDescription = this.editMyTask.TaskDescription;
      objItem.AssignTo = this.editMyTask.AssignTo;
      objItem.Priority = this.editMyTask.Priority;
      objItem.TaskOwner = this.editMyTask.TaskOwner;
      objItem.EstimatedTime = this.editMyTask.EstimatedTime;
      objItem.PredecessorId = this.editMyTask.PredecessorId;
      objItem.PlannedStartDate = this.editMyTask.PlannedStartDate;
      objItem.PlannedEndDate = this.editMyTask.PlannedEndDate;
      objItem.RemainderForStartDate = this.editMyTask.RemainderForStartDate;
      objItem.RemainderForEndDate = this.editMyTask.RemainderForEndDate;
      objItem.IsPrivate = this.editMyTask.IsPrivate;
      objItem.DisplayOrder = this.editMyTask.DisplayOrder;
      objItem.Status = this.editMyTask.Status;
      objItem.IsReOpen = this.editMyTask.IsReOpen;
      objItem.ReOpenCount = this.editMyTask.ReOpenCount;
      objItem.IsTimeSheetSaved = this.editMyTask.IsTimeSheetSaved;
      objItem.TimeSheetDate = this.editMyTask.TimeSheetDate;
      objItem.ActualTime = this.editMyTask.ActualTime;
      objItem.Comments = this.editMyTask.Comments;
      objItem.CreatedBy = this.editMyTask.CreatedBy;
      objItem.ModifiedBy = this.editMyTask.ModifiedBy;
      objItem.ActualStartDate = this.editMyTask.ActualStartDate;
      objItem.ActualCompletedDate = this.editMyTask.ActualCompletedDate;
      objItem.LoggedinUser = this.userDetail.SiteUserId;
      objItem.CheckList = this.CheckList;
      objItem.CompletionComment = this.editMyTask.CompletionComment;
      this.addEditMyTask(objItem);
      // $('#addMyTask').modal('hide');
    } else {
      if (this.greater || this.actualDateGreater) {
        this._sharedService.ShowMessage(
          "warning|Start Date should be greater than Due Date"
        );
      }
    }
  }

  public EditMyTask(item: any) {
    let objItem: any = item;
    this.editMyTask.TaskId = objItem[0].TaskId;
    this.editMyTask.Customer_Id = objItem[0].Customer_Id;
    this.editMyTask.ProjectId = objItem[0].ProjectId;
    this.callFunction(this.editMyTask.ProjectId);
    if (objItem[0].ModuleId == null) this.editMyTask.ModuleId = "";
    else this.editMyTask.ModuleId = objItem[0].ModuleId;
    if (objItem[0].ParentTaskId == null) this.editMyTask.ParentTaskId = "";
    else this.editMyTask.ParentId = objItem[0].ParentTaskId;

    this.editMyTask.TaskGroupId = objItem[0].TaskGroupId;

    this.editMyTask.TaskTypeId = objItem[0].TaskTypeId;
    this.editMyTask.TaskDescription = objItem[0].TaskDescription;
    this.editMyTask.TaskName = objItem[0].TaskName;
    if (objItem[0].AssignedTo == null) this.editMyTask.AssignTo = "";
    else this.editMyTask.AssignTo = objItem[0].AssignedTo;

    this.editMyTask.Priority = objItem[0].Priority;

    this.editMyTask.TaskOwner = objItem[0].TaskOwner;
    this.editMyTask.EstimatedTime = objItem[0].EstimatedTime;
    if (objItem[0].PredecessorTaskId == null)
      this.editMyTask.PredecessorId = "";
    else this.editMyTask.PredecessorId = objItem[0].PredecessorTaskId;
    $(".date").datetimepicker({
      format: "DD/MM/YYYY",
    });
    this.editMyTask.PlannedStartDate = moment(
      new Date(objItem[0].PlannedStart)
    ).format("DD/MM/YYYY");
    this.editMyTask.PlannedEndDate = moment(
      new Date(objItem[0].PlannedEndDate)
    ).format("DD/MM/YYYY");
    if (objItem[0].ActualStartDate != null)
      this.editMyTask.ActualStartDate = moment(
        new Date(objItem[0].ActualStartDate)
      ).format("DD/MM/YYYY");
    else
      this.editMyTask.ActualStartDate = moment(new Date()).format("DD/MM/YYYY");
    if (objItem[0].ActualCompletedDate != null)
      this.editMyTask.ActualCompletedDate = moment(
        new Date(objItem[0].ActualCompletedDate)
      ).format("DD/MM/YYYY");
    this.editMyTask.RemainderForStartDate = objItem[0].ReminderStart;
    this.editMyTask.RemainderForEndDate = objItem[0].ReminderEnd;

    this.editMyTask.IsPrivate = objItem[0].IsPrivate;
    this.editMyTask.DisplayOrder = objItem[0].Position;
    this.editMyTask.Status = objItem[0].Status;
    this.editMyTask.IsReOpen = false;
    this.editMyTask.ReOpenCount = objItem[0].ReOpenedCount;
    this.editMyTask.CreatedBy = objItem[0].CreatedBy;
    this.editMyTask.ModifiedBy = objItem[0].ModifiedBy;
    this.editMyTask.ModifiedOn = objItem[0].ModifiedOn;
    this.editMyTask.IsTimeSheetSaved = false;
    this.editMyTask.TimeSheetDate = moment(new Date()).format("DD/MM/YYYY");
    this.editMyTask.PredcessorStatus = objItem[0].PredcessorStatus;
    this.editMyTask.CompletionComment = objItem[0].CompletionComment;
    this.getStatus();
  }

  addEditMyTask(objItem) {
    if (this.validate(objItem)) {
      this.showLoader = true;
      this._httpService.ajaxPost("MyTask/AddUpdateMyTask", objItem).subscribe(
        (data) => {
          var msg = data["Status"].Message.split("|");
          if (msg.length > 1) {
            msg[0] = msg[0].toLowerCase();

            if (msg[0] != "warning") {
              this._Router.navigateByUrl("/MyTaskListCustomer");
            }
            this._sharedService.ShowMessage(data["Status"].Message);
          } else {
            this._sharedService.ShowMessage(data["Status"].Message);
          }
        },
        (err) => {
          this.showLoader = false;
          this._sharedService.ShowMessage(this.constants.globalError);
        },
        () => {
          this.showLoader = false;
        }
      );
    }
  }

  validate(item) {
    var mandatory = "";
    var invalid = "";
    var functional = "";

    if (item.ProjectId == "" || item.ProjectId == null) {
      mandatory = mandatory + "<br>Project";
    }
    if (item.TaskGroupId == "" || item.TaskGroupId == null) {
      mandatory = mandatory + "<br>TaskGroup";
    }
    if (item.TaskName == "" || item.TaskName == null) {
      mandatory = mandatory + "<br>TaskName";
    }
    if (item.AssignTo == "" || item.AssignTo == null) {
      mandatory = mandatory + "<br>AssignTo";
    }

    // if(item.TaskName.length >200 )
    // {
    //     mandatory = mandatory + "<br>TaskName length should be less than 200 charecter";
    // }
    // if(item.TaskDescription == "" || item.TaskDescription == null)
    // {
    //     mandatory = mandatory + "<br>TaskDescription";
    // }
    if (
      item.TaskDescription != "" &&
      item.TaskDescription != null &&
      item.TaskDescription.length > 2000
    ) {
      mandatory =
        mandatory +
        "<br>TaskDescription length should be less than 2000 charecter";
    }
    if (item.Priority == "" || item.Priority == null) {
      mandatory = mandatory + "<br>Priority";
    }
    if (item.TaskOwner == "" || item.TaskOwner == null) {
      mandatory = mandatory + "<br>TaskOwner";
    }
    if (item.PlannedStartDate == "" || item.PlannedStartDate == null) {
      mandatory = mandatory + "<br>PlannedStartDate";
    }
    if (item.PlannedEndDate == "" || item.PlannedEndDate == null) {
      mandatory = mandatory + "<br>PlannedEndDate";
    }
    if (
      item.Status == this.constants.taskStatus.Completed &&
      (item.CompletionComment == "" || item.CompletionComment == null)
    ) {
      mandatory = mandatory + "<br>Comment";
    }

    //   if(item.IsTimeSheetSaved==true){

    //     if(item.TimeSheetDate == "" || item.TimeSheetDate == null )
    //     {
    //         mandatory = mandatory + "<br>TimeSheetDate";
    //     }

    //     if(item.ActualTime == "" || item.ActualTime == null )
    //     {
    //         mandatory = mandatory + "<br>ActualTime";
    //     }

    //     if(item.Comments == "" || item.Comments == null )
    //     {
    //         mandatory = mandatory + "<br>Comments";
    //     }
    //    else if(item.Comments.length >2000 )
    //     {
    //         mandatory = mandatory + "<br>Comments length should be less than 2000 charecter";
    //     }

    //  }

    if (mandatory == "" && invalid == "" && functional == "") {
      return true;
    } else {
      var msg = "";
      if (mandatory != "") {
        msg = msg + "Please enter : " + mandatory;
        msg = msg + "<br>";
      }
      if (invalid != "") {
        msg = msg + "Please enter valid : " + invalid;
        msg = msg + "<br>";
      }
      if (functional != "") {
        msg = msg + functional;
      }
      this._sharedService.ShowMessage("error|" + msg);
    }
    return false;
  }
  public OnGreater(start, end) {
    var startDate = moment(start, "DD/MM/YYYY");
    var EndDate = moment(end, "DD/MM/YYYY");
    if (
      startDate > EndDate ||
      start == "" ||
      start == null ||
      start == "undefined"
    ) {
      this._sharedService.ShowMessage(
        "warning|end Date should be greater than Start Date"
      );
      this.greater = true;
    } else {
      this.greater = false;
    }
  }
  public OnGreaterTaskEndDate() {
    var startDate = moment(this.editMyTask.ActualStartDate, "DD/MM/YYYY");

    var EndDate = moment(this.editMyTask.ActualCompletedDate, "DD/MM/YYYY");
    if (
      startDate > EndDate ||
      this.editMyTask.ActualStartDate == "" ||
      this.editMyTask.ActualStartDate == null ||
      this.editMyTask.ActualStartDate.toLowerCase() == "undefined"
    ) {
      this._sharedService.ShowMessage(
        "warning|end Date should be greater than Start Date"
      );
      this.actualDateGreater = true;
    } else {
      this.actualDateGreater = false;
    }
  }
}



/** WEBPACK FOOTER **
 ** ./TypeScripts/MyTask/MyTaskListCustomer.component.ts
 **/